import { ensureNoTrailingSlash } from 'utils/Urls';
import { normalizeSlug } from './normalizeSlug';

export function getLocaleRouteBySlug(slug?: string, baseUrl?: string) {
  const pathname = normalizeSlug(slug);
  const newLocalePath = baseUrl ? `${ensureNoTrailingSlash(baseUrl)}${pathname}` : pathname;

  return newLocalePath === '/'
    ? ['/', '/m/*']
    : [ensureNoTrailingSlash(newLocalePath), `${newLocalePath}/m/*`];
}
